module.exports = "/images/Entertaiment Center.svg?2317aab7f404a2813b936b6b9fa8728e";